
import { Product } from './types';

export const INITIAL_PRODUCTS: Product[] = [
  {
    id: 'p5',
    model: 'Model π Standard',
    color: 'Pearl White',
    colorHex: '#F5F5F7',
    price: 299,
    deposit: 89.7,
    stock: 40000,
    totalAllocation: 40000,
    percentage: '40%',
    description: 'Minimalist dual-lens gateway. The pure entry point into the Starlink-connected future of communication.',
    features: ['Starlink Global Access', 'Solar Energy Back', 'Simplified Core'],
    imageUrl: 'https://zlbemopcgjohrnyyiwvs.supabase.co/storage/v1/object/public/materials/model/MODEL4.png',
    logistics: 'Global Free Shipping',
    isLimited: false
  },
  {
    id: 'p1',
    model: 'Model π Genesis',
    color: 'Fire Red',
    colorHex: '#DC2626',
    price: 359,
    deposit: 107.7,
    stock: 11000,
    totalAllocation: 11000,
    percentage: '11%',
    description: 'The iconic speed signature. High-performance triple-lens optics for 8K satellite-uplinked broadcasting.',
    features: ['8K Satellite Streaming', 'High-Speed Processor', 'Signature Red Finish'],
    imageUrl: 'https://zlbemopcgjohrnyyiwvs.supabase.co/storage/v1/object/public/materials/model/MODEL3.png',
    logistics: 'Global Free Shipping',
    isLimited: false
  },
  {
    id: 'p2',
    model: 'Model π Genesis',
    color: 'Forest Green',
    colorHex: '#166534',
    price: 359,
    deposit: 107.7,
    stock: 11000,
    totalAllocation: 11000,
    percentage: '11%',
    description: 'Lustrous, organic emerald finish. Built with a sustainable titanium-recycled frame.',
    features: ['Bio-Sensing Core', 'Sustainable Titanium', 'Starlink 2.0 Ready'],
    imageUrl: 'https://zlbemopcgjohrnyyiwvs.supabase.co/storage/v1/object/public/materials/model/MODEL5.png',
    logistics: 'Global Free Shipping',
    isLimited: false
  },
  {
    id: 'p3',
    model: 'Model π Genesis',
    color: 'Stellar Purple',
    colorHex: '#6B21A8',
    price: 359,
    deposit: 107.7,
    stock: 11000,
    totalAllocation: 11000,
    percentage: '11%',
    description: 'Deep, galactic violet tones. Optimized for low-light astrophotography.',
    features: ['Astrophotography Mode', 'Quantum Privacy Glass', 'Deep Space Signal'],
    imageUrl: 'https://zlbemopcgjohrnyyiwvs.supabase.co/storage/v1/object/public/materials/model/MODEL6.png',
    logistics: 'Global Free Shipping',
    isLimited: false
  },
  {
    id: 'p4',
    model: 'Model π Genesis',
    color: 'Flame Orange',
    colorHex: '#EA580C',
    price: 359,
    deposit: 107.7,
    stock: 11000,
    totalAllocation: 11000,
    percentage: '11%',
    description: 'Bold, kinetic energy. Featuring high-efficiency cooling for intensive processing.',
    features: ['Advanced Thermal Logic', 'Kinetic Matte Grip', 'Neural-Link Compatible'],
    imageUrl: 'https://zlbemopcgjohrnyyiwvs.supabase.co/storage/v1/object/public/materials/model/MODEL2.png',
    logistics: 'Global Free Shipping',
    isLimited: false
  },
  {
    id: 'p6',
    model: 'Model π Genesis',
    color: 'Deep Sea Cyan',
    colorHex: '#0891B2',
    price: 359,
    deposit: 107.7,
    stock: 11000,
    totalAllocation: 11000,
    percentage: '11%',
    description: 'Marine-grade resilience. Optimized for underwater operations.',
    features: ['IP69K Waterproof', 'Dual-Phase Cooling', 'Marine Blue Coating'],
    imageUrl: 'https://zlbemopcgjohrnyyiwvs.supabase.co/storage/v1/object/public/materials/model/MODEL1.png',
    logistics: 'Global Free Shipping',
    isLimited: false
  },
  {
    id: 'p7',
    model: 'Model π Ultra',
    color: 'Black Silver',
    colorHex: '#1F2937',
    price: 799,
    deposit: 239.7,
    stock: 5000,
    totalAllocation: 5000,
    percentage: '5%',
    description: 'The pinnacle of industrial design. Cybertruck-inspired angularity with a massive foldable liquid display.',
    features: ['Ultra-High Performance', 'Dual-Fold Design', 'Mars-Relay Access'],
    imageUrl: 'https://zlbemopcgjohrnyyiwvs.supabase.co/storage/v1/object/public/materials/model/MODEL%20APPI.png',
    logistics: 'Priority Air Freight',
    isLimited: true
  }
];